import { defineApiActionTypes } from 'store/common/action-helpers';

const prefix = 'features/admin/skills';

export const CREATE_SKILL = defineApiActionTypes(`${prefix}/CREATE_SKILL`);

export const DELETE_SKILL = defineApiActionTypes(`${prefix}/DELETE_SKILL`);

export const FETCH_SKILLS = defineApiActionTypes(`${prefix}/FETCH_SKILLS`);
